import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    newBadge: 'NEW',
    popularBadge: 'HOT',
  },
  ru: {
    newBadge: 'НОВЫЙ',
    popularBadge: 'ХИТ',
  },
  uz: {
    newBadge: 'YANGI',
    popularBadge: 'XIT',
  },
  fa: {
    newBadge: 'جدید',
    popularBadge: 'داغ',
  },
  pt: {
    newBadge: 'NOVO',
    popularBadge: 'HIT',
  },
  tr: {
    newBadge: 'YENİ',
    popularBadge: 'HİT',
  },
  uk: {
    newBadge: 'НОВИНКА',
    popularBadge: 'ХІТ',
  },
  de: {
    newBadge: 'NEU',
    popularBadge: 'HOT',
  },
  es: {
    newBadge: 'NUEVO',
    popularBadge: 'HOT',
  },
  pl: {
    newBadge: 'NOWOŚĆ',
    popularBadge: 'HIT',
  },
});
